export const formatMoney = (num: number) => {
	const result = num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	return result;
};
